import { NumericalKey } from "./utilityTypes";

type AggregateNumericalFieldProps<T> = {
  items?: T[];
  fieldKey: NumericalKey<T>;
};
export const aggregateNumericalField = <T>({
  items,
  fieldKey,
}: AggregateNumericalFieldProps<T>) => {
  if (!items) return 0;

  let sum = 0;
  items.forEach((item) => {
    const value = item[fieldKey];
    if (typeof value === "number") {
      sum += value;
    }
  });

  return sum.toLocaleString("en-GB", { maximumFractionDigits: 2 });
};
